import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { screenSmMax, spacer4, spacer8, spacer20, spacer40, ButtonIcon, Type, IconChevronLeft, IconChevronRight, cssColorValue } from '@spotify-internal/encore-web';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { DELAYS, ImageAspectBox1x1, HeadlineWithSupertextComponent, fadeInAnimation, FeaturedContentHeadline, withAnimationContext } from '../../ui';
import { formatText } from '../../utils';
import { useTracking } from '../../Tracking';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MiniCarouselNoHero = styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__MiniCarouselNoHero",
  componentId: "sc-1lfwegb-0"
})(["display:flex;flex-direction:column;"]); // TODO: find a better way to reorder than using separated styled components

var HeadlineWithSupertextDesktop = styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__HeadlineWithSupertextDesktop",
  componentId: "sc-1lfwegb-1"
})(["@media (max-width:", "){display:none;}"], screenSmMax);
var HeadlineWithSupertextMobile = styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__HeadlineWithSupertextMobile",
  componentId: "sc-1lfwegb-2"
})(["display:none;@media (max-width:", "){display:initial;}"], screenSmMax);
var Bottom = styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__Bottom",
  componentId: "sc-1lfwegb-3"
})(["display:flex;flex-direction:row;padding-top:", ";padding-bottom:", ";@media (max-width:", "){padding:", " 0px;flex-direction:column;}"], spacer40, spacer20, screenSmMax, spacer20);
var Left = styled.div.attrs({
  variant: Type.body1
}).withConfig({
  displayName: "MiniCarouselNoHeroModule__Left",
  componentId: "sc-1lfwegb-4"
})(["width:45%;@media (max-width:", "){padding-right:0px;width:100%;}"], screenSmMax);
export var Arrow = styled(ButtonIcon).withConfig({
  displayName: "MiniCarouselNoHeroModule__Arrow",
  componentId: "sc-1lfwegb-5"
})(["padding:0 ", ";svg{opacity:0;}&:focus:not(:disabled){svg{opacity:1;outline:thin dotted ", ";border-bottom:0;}}@media (max-width:", "){padding:0 0;svg{opacity:1;}}"], spacer4, function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, screenSmMax);
var CarouselContainer = styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__CarouselContainer",
  componentId: "sc-1lfwegb-6"
})(["padding-left:180px;width:45%;align-items:center;display:flex;@media (max-width:", "){padding-left:0px;height:auto;display:flex;justify-content:center;width:100%;}@media (max-width:", "){.alice-carousel{width:80%;}}.alice-carousel__dots{margin:0px;padding-top:", ";height:", ";display:flex;justify-content:center;width:100%;}.alice-carousel__dots-item{width:", ";height:", ";border-radius:50%;border:none;background-color:", ";margin-left:", ";margin-right:", ";padding:0px;}.alice-carousel__dots-item.__active{background-color:", ";}@media (min-width:", "){&:hover{", " svg{opacity:1;color:", ";}}}"], screenSmMax, screenSmMax, spacer8, spacer20, spacer8, spacer8, cssColorValue('backgroundPress'), spacer4, spacer4, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, screenSmMax, Arrow, function (_ref3) {
  var theme = _ref3.theme;
  return theme.box.text;
});
var Body = withAnimationContext(styled.div.withConfig({
  displayName: "MiniCarouselNoHeroModule__Body",
  componentId: "sc-1lfwegb-7"
})(["", ";"], fadeInAnimation(DELAYS.THIRD)));
var ImageContainer = styled(ImageAspectBox1x1).withConfig({
  displayName: "MiniCarouselNoHeroModule__ImageContainer",
  componentId: "sc-1lfwegb-8"
})([""]);
export var MiniCarouselNoHeroModule = /*#__PURE__*/React.forwardRef(function (_ref4, moduleRef) {
  var _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? '' : _ref4$title,
      _ref4$headline = _ref4.headline,
      headline = _ref4$headline === void 0 ? '' : _ref4$headline,
      _ref4$supertext = _ref4.supertext,
      supertext = _ref4$supertext === void 0 ? '' : _ref4$supertext,
      _ref4$body = _ref4.body,
      body = _ref4$body === void 0 ? '' : _ref4$body,
      image = _ref4.image,
      _ref4$caption = _ref4.caption,
      caption = _ref4$caption === void 0 ? '' : _ref4$caption,
      _ref4$carouselSlides = _ref4.carouselSlides,
      carouselSlides = _ref4$carouselSlides === void 0 ? [] : _ref4$carouselSlides,
      _ref4$contentType = _ref4.contentType,
      contentType = _ref4$contentType === void 0 ? '' : _ref4$contentType;
  var t = useT();
  var slides = carouselSlides.filter(Boolean).map(function (asset) {
    return asset.fields || asset;
  });
  var fchProps = {
    supertext: supertext,
    headline: headline,
    image: image,
    useFeaturedContentHeadline: false,
    caption: caption
  };
  var ref = React.useRef(null);

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  var fireEvent = React.useCallback(function (action) {
    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : title;
    sendEvent({
      eventCategory: "Frodor - module-".concat(contentType),
      eventAction: action,
      eventLabel: label
    });
  }, [title]);

  var handleClickOnPrevButton = function handleClickOnPrevButton() {
    var current = ref.current;

    if (!current) {
      return;
    }

    var slidePrev = current.slidePrev;
    slidePrev();
    fireEvent('click', 'Arrow');
  };

  var handleClickOnNextButton = function handleClickOnNextButton() {
    var current = ref.current;

    if (!current) {
      return;
    }

    var slideNext = current.slideNext;
    slideNext();
    fireEvent('click', 'Arrow');
  };

  return /*#__PURE__*/_jsxs(MiniCarouselNoHero, {
    children: [/*#__PURE__*/_jsx(HeadlineWithSupertextMobile, {
      children: /*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
        supertext: supertext,
        headline: headline
      })
    }), image && /*#__PURE__*/_jsx(FeaturedContentHeadline, _objectSpread({}, fchProps)), /*#__PURE__*/_jsxs(Bottom, {
      ref: moduleRef,
      children: [/*#__PURE__*/_jsxs(Left, {
        children: [/*#__PURE__*/_jsx(HeadlineWithSupertextDesktop, {
          children: /*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
            supertext: supertext,
            headline: headline
          })
        }), /*#__PURE__*/_jsx(Body, {
          dangerouslySetInnerHTML: {
            __html: formatText(body)
          }
        })]
      }), /*#__PURE__*/_jsxs(CarouselContainer, {
        children: [/*#__PURE__*/_jsx(Arrow, {
          onClick: handleClickOnPrevButton,
          "aria-label": t('FRODOR_6b0335', 'Go to previous slide', ''),
          children: /*#__PURE__*/_jsx(IconChevronLeft, {
            iconSize: 32
          })
        }), /*#__PURE__*/_jsx(AliceCarousel, {
          items: slides.map(function (carouselImage, index) {
            return /*#__PURE__*/_jsx(ImageContainer, {
              children: carouselImage && /*#__PURE__*/_jsx(ContentfulImage, {
                asset: carouselImage
              })
            }, index);
          }),
          autoPlayInterval: 4000,
          autoPlayDirection: "ltr",
          autoPlay: true,
          fadeOutAnimation: true,
          mouseTrackingEnabled: true,
          buttonsDisabled: true,
          ref: ref,
          playButtonEnabled: false,
          disableAutoPlayOnAction: true,
          duration: 1000
        }), /*#__PURE__*/_jsx(Arrow, {
          onClick: handleClickOnNextButton,
          "aria-label": t('FRODOR_2f86dc', 'Go to next slide', ''),
          children: /*#__PURE__*/_jsx(IconChevronRight, {
            iconSize: 32
          })
        })]
      })]
    })]
  });
});